import React from 'react';
import { Button, ConfigProvider, Spin, Tooltip } from 'antd';
import { EnterOutlined, UploadOutlined } from '@ant-design/icons';

interface ChatInputControlsProps {
  isUploading: boolean;
  isToolRunning: boolean;
  onFileUpload: () => void;
  onSend: () => void;
}

const ChatInputControls: React.FC<ChatInputControlsProps> = ({
  isUploading,
  isToolRunning,
  onFileUpload,
  onSend
}) => {
  return (
    <div className="chat-controls" style={{ flexShrink: 0 }}>
      <Tooltip title="Upload file (PDF, DOCX, CSV, RTF, TXT)">
        <ConfigProvider theme={{
          components: {
            Button: {
              defaultBg: 'transparent',
              defaultColor: 'black',
              defaultHoverBg: 'rgba(255, 255, 255, 0.1)',
              defaultHoverColor: 'white',
            },
          },
          token: { colorPrimary: 'white' } 
        }}>
          <Button 
            icon={isUploading ? <Spin size="small" /> : <UploadOutlined />}
            onClick={onFileUpload}
            disabled={isUploading}
            style={{ background:"var(--primary-color)", flexShrink: 0 }}
            className={`upload-button ${(isUploading) ? 'disabled' : ''}`}
          />
        </ConfigProvider>
      </Tooltip>
      
      <ConfigProvider theme={{
        components: {
          Button: {
            defaultBg: 'transparent',
            defaultColor: 'black',
            defaultHoverBg: 'rgba(255, 255, 255, 0.1)',
            defaultHoverColor: 'white',
          },
        },
        token: { colorPrimary: 'white' } 
      }}>
        <Button 
          icon={<EnterOutlined />}
          onClick={onSend}
          disabled={isUploading || isToolRunning}
          style={{ background:"var(--primary-color)", flexShrink: 0 }}
          type="default"
        />
      </ConfigProvider>
    </div>
  );
};

export default ChatInputControls;
